import { forwardRef } from "react"

export const CustomDateInput = forwardRef(({ value, onClick }, ref) => (
    <input
        className="custom-date-input"
        value={value}
        onClick={onClick}
        ref={ref}
        readOnly
        inputMode="none"
    />
))

